module.exports = __webpack_public_path__ + "static/media/Olympia.d1d46c18.png";